/* =============================================
   GLAM GAS / MAXDEALS.PK — Custom JavaScript
   Dawn Theme
   ============================================= */

(function () {
  'use strict';

  /* --- 1. Featured Products Tab Filtering --- */
  function initProductTabs() {
    const tabBtns = document.querySelectorAll('.gg-tab-btn');
    const productCards = document.querySelectorAll('.gg-product-card[data-category]');

    if (!tabBtns.length) return;

    tabBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        tabBtns.forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');

        var filter = btn.getAttribute('data-filter');

        productCards.forEach(function (card) {
          if (filter === 'all' || card.getAttribute('data-category') === filter) {
            card.removeAttribute('data-hidden');
          } else {
            card.setAttribute('data-hidden', '');
          }
        });
      });
    });
  }

  /* --- 2. Hero Slider --- */
  function initHeroSlider() {
    var sliders = document.querySelectorAll('.gg-hero-slider');

    sliders.forEach(function (slider) {
      var slides = slider.querySelectorAll('.gg-slide');
      var dots = slider.querySelectorAll('.gg-slider-dot');
      var prevBtn = slider.querySelector('.gg-slider-arrow--prev');
      var nextBtn = slider.querySelector('.gg-slider-arrow--next');

      if (!slides.length) return;

      var current = 0;
      var total = slides.length;
      var autoplayInterval = null;
      var touchStartX = 0;
      var touchEndX = 0;

      function goTo(index) {
        slides[current].classList.remove('active');
        if (dots[current]) dots[current].classList.remove('active');

        current = (index + total) % total;

        slides[current].classList.add('active');
        if (dots[current]) dots[current].classList.add('active');
      }

      function startAutoplay() {
        autoplayInterval = setInterval(function () {
          goTo(current + 1);
        }, 4000);
      }

      function stopAutoplay() {
        clearInterval(autoplayInterval);
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          stopAutoplay();
          goTo(current - 1);
          startAutoplay();
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          stopAutoplay();
          goTo(current + 1);
          startAutoplay();
        });
      }

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          stopAutoplay();
          goTo(i);
          startAutoplay();
        });
      });

      /* Touch/swipe support */
      slider.addEventListener('touchstart', function (e) {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      slider.addEventListener('touchend', function (e) {
        touchEndX = e.changedTouches[0].screenX;
        var diff = touchStartX - touchEndX;
        if (Math.abs(diff) > 50) {
          stopAutoplay();
          goTo(diff > 0 ? current + 1 : current - 1);
          startAutoplay();
        }
      }, { passive: true });

      /* Init */
      goTo(0);
      startAutoplay();

      /* Pause on hover */
      slider.addEventListener('mouseenter', stopAutoplay);
      slider.addEventListener('mouseleave', startAutoplay);
    });
  }

  /* --- 3. Wishlist Heart Toggle (localStorage) --- */
  function initWishlist() {
    var wishlistKey = 'gg_wishlist';

    function getWishlist() {
      try {
        return JSON.parse(localStorage.getItem(wishlistKey)) || [];
      } catch (e) {
        return [];
      }
    }

    function saveWishlist(list) {
      try {
        localStorage.setItem(wishlistKey, JSON.stringify(list));
      } catch (e) {}
    }

    function updateBadges() {
      var list = getWishlist();
      var badges = document.querySelectorAll('.header__wishlist-badge');
      badges.forEach(function (b) {
        b.textContent = list.length;
        b.style.display = list.length > 0 ? 'flex' : 'none';
      });
    }

    function bindButtons() {
      document.querySelectorAll('.gg-wishlist-btn').forEach(function (btn) {
        var productId = btn.getAttribute('data-product-id');
        var list = getWishlist();
        if (productId && list.includes(productId)) {
          btn.classList.add('active');
          btn.innerHTML = '&#9829;';
        }

        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var list = getWishlist();
          var id = btn.getAttribute('data-product-id');
          if (!id) return;

          var idx = list.indexOf(id);
          if (idx === -1) {
            list.push(id);
            btn.classList.add('active');
            btn.innerHTML = '&#9829;';
          } else {
            list.splice(idx, 1);
            btn.classList.remove('active');
            btn.innerHTML = '&#9825;';
          }
          saveWishlist(list);
          updateBadges();
        });
      });
    }

    bindButtons();
    updateBadges();
  }

  /* --- 4. Scroll-to-Top Button --- */
  function initScrollTop() {
    var btn = document.querySelector('.gg-scroll-top-btn');
    if (!btn) return;

    window.addEventListener('scroll', function () {
      if (window.scrollY > 300) {
        btn.classList.add('visible');
      } else {
        btn.classList.remove('visible');
      }
    }, { passive: true });

    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* --- 5. Announcement bar: CSS animation handles marquee.
         This JS block creates the duplicate items for seamless loop. --- */
  function initMarquee() {
    var track = document.querySelector('.gg-announcement-bar__track');
    if (!track) return;
    /* Duplicate children for seamless infinite scroll */
    var items = Array.from(track.children);
    items.forEach(function (item) {
      var clone = item.cloneNode(true);
      track.appendChild(clone);
    });
  }

  /* --- 6. Card Add-to-Cart (AJAX) ---
     Intercept forms rendered in product cards and submit via AJAX
     so users are not routed to the product page. Mirrors product-form behaviour. --- */
  function initCardAddToCart() {
    // Broader selector: catch all forms in product cards
    var forms = document.querySelectorAll('form.md-product-card__form, form[data-type="add-to-cart-form"], .gg-product-card form[action="/cart/add"], form[action="/cart/add"]');
    if (!forms.length) return;

    function bindForm(form) {
      // Avoid binding the same form multiple times
      if (form.__ggBoundAddToCart) return;
      form.__ggBoundAddToCart = true;

      form.addEventListener('submit', function (evt) {
        evt.preventDefault();

        var submitBtn = form.querySelector('[type="submit"], button[name="add"]');
        if (submitBtn && submitBtn.getAttribute('aria-disabled') === 'true') return;

        if (submitBtn) {
          submitBtn.setAttribute('aria-disabled', 'true');
          submitBtn.classList.add('loading');
        }

        var config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        var formData = new FormData(form);

        var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cart) {
          try {
            formData.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
            formData.append('sections_url', window.location.pathname);
            if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
          } catch (e) {}
        }

        config.body = formData;

        fetch("" + routes.cart_add_url, config)
          .then(function (response) { return response.json(); })
          .then(function (response) {
            if (response.status) {
              console.error('Add to cart error:', response);
              return;
            }

            if (!cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (typeof cart.renderContents === 'function') {
              cart.renderContents(response);
            }
          })
          .catch(function (err) { console.error(err); })
          .finally(function () {
            if (submitBtn) {
              submitBtn.classList.remove('loading');
              submitBtn.removeAttribute('aria-disabled');
            }
          });
      });
    }

    forms.forEach(bindForm);

    // Re-bind forms when DOM changes (for dynamically added quick-add modals)
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.addedNodes.length) {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType === 1) { // Element node
              var newForms = node.querySelectorAll('form.md-product-card__form, form[data-type="add-to-cart-form"], form[action="/cart/add"]');
              newForms.forEach(bindForm);
            }
          });
        }
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  /* --- Init --- */
  function initCustomTheme() {
    initProductTabs();
    initHeroSlider();
    initWishlist();
    initScrollTop();
    initMarquee();
    initCardAddToCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomTheme);
  } else {
    initCustomTheme();
  }

})();
